import { render, staticRenderFns } from "./BackorderResults.vue?vue&type=template&id=87f8187e"
import script from "./BackorderResults.ts?vue&type=script&lang=ts&external"
export * from "./BackorderResults.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports